var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c(_vm.currentComp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }